export default "__VITE_ASSET__1xdWqrZU__"